import platConfig from "../static/config/index.js";

export const state = () => ({
  ...platConfig,
});

export const mutations = {};

export const getters = {};
